// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29d6r","content":"styles_content__3c4wo","tableWrap":"styles_tableWrap__1CIMF"};